module.exports = __webpack_public_path__ + "img/relatetheme-icon.5c7a70d.png";